'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var baseButton = require('../../../../atoms/button/base-button/base-button.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * `tab` indicates an interactive element inside a `tablist` that, when activated, displays its associated `tabpanel`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 *
 * @param props TabButtonProps
 */ const TabButton = (props)=>{
    const { active =false , activeIndex , children , className , focusIndex , id , index , tabPanelId , ...otherProps } = props;
    const ref = React.useRef(null);
    React.useEffect(()=>{
        if (activeIndex === index && ref?.current) {
            ref.current.focus();
        }
    }, [
        activeIndex
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (focusIndex !== null && focusIndex === index && ref?.current) {
            ref.current.focus();
        }
    }, [
        focusIndex
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React__default.default.createElement(baseButton.BaseButton, _extends({}, otherProps, {
        ref: ref,
        "aria-controls": tabPanelId,
        "aria-selected": active,
        className: classnames__default.default({
            'bf-tabs__tab': true,
            [`${className}`]: !!className
        }),
        id: id,
        role: "tab",
        tabIndex: active ? undefined : -1,
        type: "button"
    }), children);
};

exports.TabButton = TabButton;
//# sourceMappingURL=tab-button.js.map
